import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { FaUpload } from 'react-icons/fa';
import './CreateShelf.css';  // Optional custom CSS file for styling
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import ToastrNotifi from '../../../Utilities/ToastrNotifi';
import { useBreadcrumbs } from '../../../Utilities/Breadscrumb/BreadcrumbContext';
import { useAddShelve } from '../../../hooks/useShelveData';

const CreateShelf = () => {
    const [shelfName, setShelfName] = useState('');
    const [shelfImage, setShelfImage] = useState(null);
    const [shelfDescription, setShelfDescription] = useState('');
    const beURL = localStorage.getItem('BeURL');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);  // Track loading state
    const [error, setError] = useState(false);
    const [errors, setErrors] = useState({});


    const { mutate: addShelve } = useAddShelve();



    const handleImageUpload = (e) => {
        setShelfImage(URL.createObjectURL(e.target.files[0]));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Prepare the form data
        const formData = new FormData();
        formData.append('shelfName', shelfName);
        formData.append('shelfDescription', shelfDescription);
        formData.append('shelfImage', e.target.shelfImage.files[0]);  // Append file from input


        addShelve(formData, {
            onError: (error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors); // Set backend errors in state
                    const errorMessages = Object.values(error.response.data.errors).flat();
                    errorMessages.forEach(message => ToastrNotifi.warningToast(message));
                } else {
                    console.error('An unexpected error occurred:', error);
                    ToastrNotifi.errorToast("An unexpected error occurred. Please try again.");
                }
            },
            onSuccess: (response) => {
                ToastrNotifi.successToast('Shelf created successfully', 'success');
                console.log(response?.data.id);
                navigate(`/${response?.data.id}/${response?.data.slug}`);
            },


        });
    };

    const handleImageError = () => {
        setLoading(false);
        setError(true);
    };

    const location = useLocation();
    const { addBreadcrumb } = useBreadcrumbs();
    useEffect(() => {
        addBreadcrumb('Create New Shelve', location.pathname); // Add breadcrumb for shelves
        return () => {
            // Optionally clear breadcrumbs or manage them as needed
        };
    }, [addBreadcrumb]);
    return (
        <Container className="mt-4">
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card className="p-4 shadow-sm">
                        <h3 className="text-center mb-4">Create New Shelf</h3>
                        <Form onSubmit={handleSubmit}>
                            {/* Shelf Name */}
                            <Form.Group controlId="shelfName" className="mb-3">
                                <Form.Label>Shelf Name
                                    {errors.shelfName ? (
                                        <div className="text-danger error-text">**{errors.shelfName}</div>
                                    ) : (null)}

                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter shelf name"
                                    value={shelfName}
                                    onChange={(e) => setShelfName(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Shelf Image */}
                            <Form.Group controlId="shelfImage" className="mb-3">
                                <Form.Label>Shelf Image
                                {errors.shelfImage ? (
                                        <div className="text-danger error-text">**{errors.shelfImage}</div>
                                    ) : (null)}
                                </Form.Label>
                                <br></br>
                                <span className='text-primary infoText'>image size may not be greater than 2 MB & image must be type of jpeg, png, jpg, gif.</span>

                                <div className="custom-file-upload">
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageUpload}
                                        required
                                    />
                                    <FaUpload className="upload-icon" />
                                </div>
                                {shelfImage && (
                                    <div className="mt-3">
                                        <img width={225} src={shelfImage} alt="Shelf Preview" className="shelf-image-preview" onError={handleImageError} />
                                    </div>
                                )}
                            </Form.Group>

                            {/* Shelf Description */}
                            <Form.Group controlId="shelfDescription" className="mb-3">
                                <Form.Label>Shelf Description
                                {errors.shelfDescription ? (
                                        <div className="text-danger error-text">**{errors.shelfDescription}</div>
                                    ) : (null)}
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter shelf description"
                                    value={shelfDescription}
                                    onChange={(e) => setShelfDescription(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            {/* Submit Button */}
                            <div className="text-center">
                                <Button variant="primary" type="submit" className="px-4">
                                    Create Shelf
                                </Button>
                            </div>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CreateShelf;
